/**
 * Chat layout levers (2026-09-20). Both default ON; `=off` is the one flip
 * that takes the behaviour away without a revert.
 */

/**
 * `REACT_APP_CHAT_RAIL_RESIZE=off` hides the full-screen rail's drag handle.
 * The screen-aware default width still applies, and a width someone has
 * already stored is still honoured — this takes away the gesture, not their
 * preference, so turning it off cannot strand anyone at a width they cannot
 * change back (the default is one localStorage key away in either case).
 */
export function railResizeEnabled(env: Record<string, string | undefined> = process.env): boolean {
  return String(env.REACT_APP_CHAT_RAIL_RESIZE ?? '').trim().toLowerCase() !== 'off';
}

/**
 * `REACT_APP_CHAT_NAV_REVEAL=off` stops the chat stepping aside when someone
 * follows a link to a page of the app — back to today's behaviour, where the
 * page loads underneath a chat that is still covering it.
 */
export function chatNavRevealEnabled(env: Record<string, string | undefined> = process.env): boolean {
  return String(env.REACT_APP_CHAT_NAV_REVEAL ?? '').trim().toLowerCase() !== 'off';
}
